<template lang="pug">
b-container#page.operation
  b-row
    .col-4
      //h1 {{ msg }}
      h2 Operación
      b-form(inline v-if="show")
        b-form-group#input-counter-group(label='Counter:' description="¡Buenos dias!")
          b-form-input#input-counter.mr-sm-2(v-model="user.email" size='sm' placeholder='Usuario' disabled)
          b-button.my-2.my-sm-0(size='sm' type='submit') Salir
      //px-form(:airports="airports")
      //px-cards(title="Operaciones")
    .col-8
      h2 Detalle
      div.mb-2(v-if="loading") Cargando...
        b-spinner.ml-2(label="Cargando..." small)
      b-card-group
        px-card#resume-card(v-if="operation"
          :key='operation._id'
          :id='operation._id'
          :saleId='operation.saleId !== undefined'
          :title="operation.clientId ? operation.clientId.firstName : ''"
          :fullName="operation.clientId ? (operation.clientId.firstName + ' ' + operation.clientId.lastName): ''"
          :cardHeader="operation.passengerGroup ? operation.passengerGroup.length : ''"
          :cardFooter="undefined"
          :cardContent="operation"
          :hideButtons="true"
          :showForm="true"
          :airports="airports"
        )
</template>

<script>
// @ is an alias to /src
import PxCard from "@/components/PxCard.vue";
import PxForm from "@/components/PxForm.vue";

import { mapState, mapGetters } from "vuex";

export default {
  name: "Operation",
  components: {
    PxCard,
    PxForm,
  },
  data() {
    return {
      /*form: {
        firstName: "",
        lastName: "",
        documentType: "",
        documentNumber: "",
        email: "",
        phoneNumber: "",
        homeAddress: "",
        occupation: "",
        maritalStatus: "single",
        passengerNumber: 1,
        passengers: [
          {
            passengerIndex: 0,
            passengerType: undefined,
            firstName: "",
            lastName: "",
            passengerDocumentType: "",
            documentType: undefined,
            documentNumber: "",
            birthdate: "",
            phone: "",
            email: "",
            address: "",
            occupation: "",
            maritalStatus: "single",
          },
        ],
        currency: "",
        total: "0",
        destinations: [],
        hasSale: [],
        showDetails: [],
        searchLocation: "",
        it: "",
        img: "",
        receiptNumber: "",
        saleDate: "",
        saleDescription: "",
      },
      passengerTypes: [
        { text: "", value: null },
        { text: "ADT Adult", value: "adult" },
        { text: "CHD Child", value: "child" },
        { text: "INF Infant without a seat", value: "inf" },
        //"INS infant with a seat",
        //"UNN unaccompanied child",
      ],
      maritalStatusList: [
        //{ text: "", value: null },
        { text: "Soltero", value: "single" },
        { text: "Casado", value: "married" },
        { text: "Viudo", value: "widow" },
        { text: "Divorciado", value: "divorced" },
        //"En relación",
        //"Conviviente",
      ],
      paymentMethods: [
        //{ text: "", value: null },
        { text: "Efectivo", value: "cash" },
        { text: "Tarjeta", value: "credit" },
        { text: "Otros", value: "other" },
      ],
      currencies: [
        { text: "", value: null },
        { text: "Nuevos soles [PEN]", value: "pen" },
        { text: "Dólares americanos [USD]", value: "usd" },
        { text: "Euro [EUR]", value: "eur" },
      ],
      documentTypes: [{ text: "", value: null }, "DNI", "CE", "Pasaporte"],*/
      loading: true,
      show: true,
    };
  },
  computed: {
    ...mapState(["user", "operations", "airports"]),
    ...mapGetters(["user", "operations", "airports"]),
    operation: function () {
      console.log("operation");
      return this.operations.find((operation) => {
        if (operation._id == this.$route.params.id) {
          this.loading = false;
        }
        return operation._id == this.$route.params.id;
      });
    },
    /*passengerCount() {
      let passengerArray = Array(parseInt(this.form.passengerNumber));
      passengerArray.fill("");
      return passengerArray;
    },*/
  },
  mounted() {
    //this.$store.dispatch("loadItems");
    //this.loading = false;
    /*console.log(this.$route.params.id);*/
  },
  /*filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },*/
  methods: {
    /*async onSubmit(evt) {
      evt.preventDefault();
      try {
        this.$store.dispatch("addOperation", this.form);
        //this.$router.go("/");
      } catch (error) {
        console.log(error);
      } finally {
        console.log("operationSubmited");
      }*/
    /*alert(this.form);
      this.$store.dispatch("addOperation", {
        clientId: {
          firstName: this.form.firstName,
        },
        passangerGroupID: {
          passengerNumber: this.form.passengerNumber,
        },
      });
      //this.$store.dispatch("loadItems");
      alert(JSON.stringify(this.form));*/
    //},
    /*onReset(evt) {
      evt.preventDefault();
      console.log(this.$store);
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    addLocation() {
      this.form.destinations.push({ mensaje: this.form.searchLocation });
    },
    clearLocations() {
      this.form.destinations = [];
    },
    changePassengerNumber(value) {
      let val = parseInt(value);
      let more = val > this.form.passengers.length;
      console.log(val, this.form.passengers.length);
      if (more) {
        for (let i = this.form.passengers.length; i < val; i++) {
          let newPassenger = { ...this.form.passengers[0] };
          newPassenger.passengerIndex = i;
          this.form.passengers[i] = newPassenger;
          this.$forceUpdate();
        }
      } else {
        console.log(val, this.form.passengers.length);
        for (let i = this.form.passengers.length; i > val; i--) {
          this.form.passengers.pop();
          this.$forceUpdate();
        }
        console.log(this.form.passengers);
      }
    },*/
  },
};
</script>
